module.exports = __webpack_public_path__ + "img/avatar3.1586050.svg";